import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { SERVERURL } from "../../ServerUrl";
import formatAnnouncement from "./formatAnnouncement";
import "./EventMarquee.css";

// Shown until the admin announcement loads, and kept if the request fails or
// nothing has been uploaded yet. The live copy is set at /admin/AddAnnouncement.
const FALLBACK_BANNER =
  '<strong>EVENT ALERT:</strong> We are thrilled to announce the <strong>TCH Venture Connect - KBW 2026 Edition</strong> on Thursday 1st October 2026 in Seoul. <a href="https://luma.com/5pn4rjyy" target="_blank" rel="noopener noreferrer">Please register to join!</a>';

// Rendered twice inside the track so the loop has no visible seam.
const REPEATS = 2;

// The admin editor (ReactQuill) wraps text in <p> blocks. They are flattened to
// inline so the whole announcement stays on the strip's single 20px line.
const BANNER_CONTENT_CLASSES = [
  "[&_p]:inline [&_p]:m-0 [&_p+p]:ml-1.5 [&_br]:hidden",
  "[&_strong]:text-white [&_strong]:font-bold",
  "[&_a]:!text-white [&_a]:underline [&_a]:underline-offset-4",
  "[&_a:hover]:!text-[#F0B90A] [&_a]:transition-colors [&_a]:duration-200",
].join(" ");

const Message = ({ html }) => (
  // `leading-5` is load-bearing: the strip's height is pinned to 40px so the
  // hero's fold maths can subtract it, and that 40 assumes a 20px line box.
  <span
    className={`shrink-0 px-8 font-headline text-[13px] leading-5 font-semibold text-white/85 whitespace-nowrap ${BANNER_CONTENT_CLASSES}`}
    dangerouslySetInnerHTML={{ __html: html }}
  />
);

const EventMarquee = () => {
  // Empty until the request settles, so the fallback never flashes before the
  // admin copy. The strip keeps its pinned height meanwhile, so nothing shifts.
  const [banner, setBanner] = useState("");

  useEffect(() => {
    axios
      .get(`${SERVERURL}/api/v1/getAnnouncement`)
      // With nothing uploaded the API sends only `message`.
      .then((response) => setBanner(response.data.banner || FALLBACK_BANNER))
      .catch((error) => {
        console.error("Error fetching announcement:", error);
        setBanner(FALLBACK_BANNER);
      });
  }, []);

  const html = useMemo(() => formatAnnouncement(banner), [banner]);

  return (
    // Slate, a lighter step on the navbar's `#010810`, so the strip reads as its
    // own band without competing with the amber buttons.
    <div className="eventMarqueeStrip w-full bg-[#29313D] overflow-hidden py-2.5">
      {/* `!flex-nowrap`: several legacy stylesheets redefine a global `.flex`
          with wrap + space-between and load after Tailwind. */}
      {banner && (
        <div className="eventMarqueeTrack flex !flex-nowrap w-max">
          {Array.from({ length: REPEATS * 2 }, (_, index) => (
            <Message key={index} html={html} />
          ))}
        </div>
      )}
    </div>
  );
};

export default EventMarquee;
